import React from 'react';

export interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  color?: 'accent' | 'blue' | 'white' | 'gray';
  className?: string;
  'aria-label'?: string;
}

const sizeClasses: Record<NonNullable<SpinnerProps['size']>, string> = {
  sm: 'h-4 w-4',
  md: 'h-6 w-6',
  lg: 'h-8 w-8',
};

const colorClasses: Record<NonNullable<SpinnerProps['color']>, string> = {
  accent: 'text-accent',
  blue: 'text-blue-500',
  white: 'text-white',
  gray: 'text-text-quaternary',
};

const Spinner: React.FC<SpinnerProps> = ({
  size = 'md',
  color = 'accent',
  className = '',
  'aria-label': ariaLabel = 'Loading',
}) => {
  return (
    <svg
      className={`
        animate-spin
        ${sizeClasses[size]}
        ${colorClasses[color]}
        ${className}
      `.trim().replace(/\s+/g, ' ')}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      role="status"
      aria-label={ariaLabel}
    >
      <circle
        className="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth="4"
      />
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      />
    </svg>
  );
};

export default Spinner;
